<template>
  <v-container>
    <v-container>
      <v-container>
        <h2>Planilha de Avanço</h2>
      </v-container>

      <v-container :class="themeClass" class="d-flex filterCardContainer" style="padding: 0px 12px;">
        <v-tabs v-model="activeTab">
          <v-tab><v-icon>mdi-table</v-icon>PAV</v-tab>
          <!-- <v-tab>Dashboard</v-tab> -->
        </v-tabs>
        <v-tabs v-model="activeTab">
          <v-container class="d-flex justify-start flex-wrap" v-if="activeTab === 0">
            <template v-for="(value, key) in filters">
              <v-btn :key="key" v-if="value" style="box-shadow: none; height: 30px; margin: 0px 8px;" small
                @click="clearFilter(key)">
                {{ key }}: {{ value }}
                <v-icon small class="ml-1">mdi-close</v-icon>
              </v-btn>
            </template>
          </v-container>
        </v-tabs>
        <v-hover>
          <v-btn color="#230BC1"
            style="color: #FFF; box-shadow: none; height: 30px; width: 100px; margin-right: 8px; align-self: center"
            @click="saveLines()">
            <v-icon>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-hover>
        <v-hover>
          <v-btn color="#FFF"
            style="color: #000; border: 1px solid #e1e1e1; box-shadow: none; height: 30px; width: 100px; align-self: center"
            @click="openFilterDialog">
            <v-icon>mdi-tune-vertical</v-icon>
            Filtros
          </v-btn>
        </v-hover>
      </v-container>
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-tabs-window-item value="PAV">

            <v-data-table :headers="headers" :items="items" :items-per-page-options="customItemsPerPageOptions"
              @update:items-per-page="updateItemsPerPage" :footer-props="{
                'items-per-page-options': [50, 100, 200, 500, 1000]
              }" @update:page="updatePage" item-value="seq" class="elevation-1"
              fixed-header :height=" items.length > 9 ? '73vh' : '100%'">
              <template v-slot:item="{ item }"> 
                <tr :style="{ 'background-color': !item.seq.includes('.') ? '#D3D3D3' : ''}">
                  <td v-for="header in headers" :key="header.value">
                    <!-- Select para "Status do Item" -->
                    <v-select
                      v-if="header.value === 'itemStatus'"
                      v-model="item[header.value]"
                      :items="statusOptions"
                      dense
                      single-line
                      hide-details
                      class="editable-select"
                      @change="trackEdit(item)"
                    ></v-select>

                    <!-- Outros campos editáveis -->
                    <v-text-field
                      v-else-if="editableColumns.includes(header.value)"
                      :disabled="item.seq.includes('.') ? false : true"
                      v-model="item[header.value]"
                      :type="header.type === 'number' ? 'number' : 'text'"
                      dense
                      @keyup="if(header.type === 'number' && Number(item[header.value]) > Number(item.totalWeight)) item[header.value] = item.totalWeight;"
                      single-line
                      hide-details
                      
                      @change="trackEdit(item)"
                    ></v-text-field>

                    <!-- Campos de data -->
                    <v-text-field
                      v-else-if="dateColumns.includes(header.value)"
                      v-model="item[header.value]"
                      type="date"
                      class="editable-field date-input"
                      dense
                      :disabled="header.value == 'updateDate' ? true : false"
                      single-line
                      hide-details
                      @change="trackEdit(item)"
                    ></v-text-field>

                    <!-- Exibir valores normais -->
                    <span v-else>{{ item[header.value] }}</span>
                  </td>
                </tr>
              </template>

            </v-data-table>

            <v-dialog v-model="filterDialog" max-width="600" class="filterDialog">
              <v-card>
                <v-container class="dialogTitle d-flex justify-sm-space-between align-center">
                  <v-card-title :class="themeClass" class="headline"
                    style="font-size: 16px !important; font-weight: bold;">
                    <v-icon class="text-h6">mdi-tune-vertical</v-icon>
                    Filtros
                  </v-card-title>
                  <div>
                    <v-btn text class="filter_button" @click="clearAllFilters"
                      style="background-color: red; color: #FFF !important; margin-right: 5px;">
                      <v-icon class="text-h6">mdi-trash-can-outline</v-icon>
                      Limpar
                    </v-btn>
                  </div>
                </v-container>
                <v-card-text>
                  <v-form ref="filterForm">
                    <v-row dense>
                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.jobCodigo" :items="filterJob" label="JOB" dense outlined
                          style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione um JOB"></v-combobox>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.osCodigo" :items="filterOs" label="Ordem de Serviço" dense outlined
                          style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione uma OS"></v-combobox>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.osItemStatus" :items="statusOptions" label="Status" dense outlined
                          style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione um status"></v-combobox>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field v-model="filters.osItemDescricao" label="Descrição"
                          placeholder="Digite a descrição" outlined dense></v-text-field>
                      </v-col>


                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.fornecedorNome" :items="filterSupplier" label="Fornecedor" dense
                          outlined style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione um fornecedor"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox :items="[]" label="Desenho Fabricação / Posição" dense outlined
                          style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione um desenho fabricação / posição"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox :items="[]" label="Desenho Montagem / Posição" dense outlined style="color: #808080"
                          item-text="text" item-value="value"
                          placeholder="Selecione um desenho montagem / posição"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.pedidoDeCompraCodigo" :items="filterPedidoDeCompra"
                          label="Pedido de Compra" dense outlined style="color: #808080" item-text="text"
                          item-value="value" placeholder="Selecione um pedido de compra"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox v-model="filters.destino" :items="['Cliente','Fornecedor','Fábrica']"
                          label="Destino" dense outlined style="color: #808080" item-text="text" item-value="value"
                          placeholder="Selecione um destino"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox label="Lista de Embarque" dense outlined style="color: #808080" item-text="text"
                          item-value="value" placeholder="Selecione uma lista de embarque"></v-combobox>
                      </v-col>


                      <v-col cols="12" md="6">
                        <v-combobox label="Nota Fiscal" dense outlined style="color: #808080" item-text="text"
                          item-value="value" placeholder="Selecione uma nota fiscal"></v-combobox>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-combobox label="ROM" dense outlined style="color: #808080" item-text="text"
                          item-value="value" placeholder="Selecione um rom"></v-combobox>
                      </v-col>

                      <div style="width: 100%; border: 1px solid #e1e1e1; margin-top: 10px; margin-bottom: 10px;"></div>

                      <v-col cols="12">
                        <h2>Prazo</h2>

                        <v-container class="d-flex justify-sm-space-between pl-0 pb-0">
                          <v-col cols="12" md="6" class="pl-0">
                            <label for="deadlineStart">Início</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="deadlineStart">
                          </v-col>

                          <v-col cols="12" md="6">
                            <label for="deadlineEnd">Fim</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="deadlineEnd">
                          </v-col>
                        </v-container>
                      </v-col>

                      <div style="width: 100%; border: 1px solid #e1e1e1; margin-top: 10px; margin-bottom: 10px;"></div>

                      <v-col cols="12">
                        <h2>Novo Prazo</h2>

                        <v-container class="d-flex justify-sm-space-between pl-0 pb-0">
                          <v-col cols="12" md="6" class="pl-0">
                            <label for="newDeadlineStart">Início</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="newDeadlineStart">
                          </v-col>

                          <v-col cols="12" md="6">
                            <label for="newDeadlineEnd">Fim</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="newDeadlineEnd">
                          </v-col>
                        </v-container>
                      </v-col>

                      <div style="width: 100%; border: 1px solid #e1e1e1; margin-top: 10px; margin-bottom: 10px;"></div>

                      <v-col cols="12">
                        <h2>Data Embarque</h2>

                        <v-container class="d-flex justify-sm-space-between pl-0 pb-0">
                          <v-col cols="12" md="6" class="pl-0">
                            <label for="newDeadlineStart">Início</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="newDeadlineStart">
                          </v-col>

                          <v-col cols="12" md="6">
                            <label for="newDeadlineEnd">Fim</label>
                            <input type="date" class="filterInputDate" style="color: #808080" name="newDeadlineEnd">
                          </v-col>
                        </v-container>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-dialog>

            <!-- Dialog de Confirmação de Exclusão -->
            <div v-if="showDeleteModal" class="custom-modal-overlay">
              <v-container class="custom-modal" max-width="500px">
                <v-card>
                  <v-card-title class="headline">
                    Confirmar Exclusão
                  </v-card-title>
                  <v-card-text>
                    Tem certeza de que deseja excluir este item?
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="cancelDeletion">Cancelar</v-btn>
                    <v-btn color="red darken-1" text @click="confirmDeletion">Excluir</v-btn>
                  </v-card-actions>
                </v-card>
              </v-container>
            </div>

          </v-tabs-window-item>
        </v-tab-item>
        <v-tab-item>
          <v-card>
            <v-card-text>Conteúdo da Página 2</v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-container>

</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

export default {
  data() {
    return {
      showDeleteModal: false,
      userEmail: '',
      itemToDelete: null, 
      activeTab: 0,
      deletedIds: [],
      newIds: [],
      filterOs: [],
      filterJob: [],
      itemsPerPage: 50, // Limite inicial de itens por página
      currentPage: 1, // Página inicial
      filterSupplier: [],
      filterPedidoDeCompra: [],
      editedItems: new Set(), // Set para armazenar os itens modificados
      filterDescription: [],
      statusOptions: [
        "Não iniciado.",
        "Aguardando matéria prima.",
        "Em preparação.",
        "Em processo de fabricação.",
        "Liberado em preto.",
        "Em processo de pintura.",
        "Aguardando inspeção.",
        "Reprovado / retrabalhos.",
        "Paralisado.",
        "Liberado pela inspeção.",
        "Expedido."
      ],
      filterDialog: false, // Controle do modal de filtros
      filters: {
        destino: "",
        osCodigo: "",
        jobCodigo: "",
        fornecedorNome: "",
        pedidoDeCompraCodigo: "",
        osItemStatus: "",
        osItemDescricao: ""
      },
      editableColumns: [
        "rawMaterial",
        "preparationCutting",
        "boilermakingMachining",
        "finishingWelding",
        "painting",
        "inspectionTests",
      ],
      tab: null,
      headers: [
        { text: "", value: "", sortable: false },
        { text: "JOB", value: "jobCodigo", width: '100px' },
        { text: "Fornecedor", value: "fornecedorNome", width: '150px' },
        { text: "PC", value: "pedidoDeCompraCodigo", width: '100px' },
        { text: "OS", value: "osCodigo", width: '100px' },
        { text: "Item", value: "osItemCodigo", width: '100px' },
        { text: "Desenho Montagem", value: "assemblyDrawing", width: '180px' },
        { text: "Revisão Montagem", value: "drawingReview", width: '180px' },
        { text: "Posição", value: "position", width: '100px' },
        { text: "Desenho Fabricação", value: "manufacturingDrawing", width: '180px' },
        { text: "Revisão Fabricação", value: "manufacturingReview", width: '180px' },
        { text: "Quantidade", value: "qtd", width: '150px' },
        { text: "Descrição", value: "description", width: '650px' },
        { text: "Peso Total", value: "totalWeight", width: '150px' },
        { text: "Matéria Prima", value: "rawMaterial", width: '150px', type: 'number' },
        { text: "Preparação / Corte", value: "preparationCutting", width: '180px', type: "number" },
        { text: "Caldeiraria / Usinagem", value: "boilermakingMachining", width: '180px', type: "number" },
        { text: "Solda / Acabemento", value: "finishingWelding", width: '180px', type: "number" },
        { text: "Pintura", value: "painting", width: '100px', type: "number" },
        { text: "Inspeção / Testes", value: "inspectionTests", width: '150px', type: "number" },
        { text: "Embarque Peso (kg)", value: "shippingWeight", width: '180px' },
        { text: "% Avanço Total", value: "fullAdvance", width: '100px' },
        { text: "Saldo da OS (kg)", value: "osBalance", width: '100px' },
        { text: "Início Fabricação", value: "startManufacturing", width: '120px' },
        { text: "Data de Atualização", value: "updateDate", width: '120px' },
        { text: "Responsável pela Atualização", value: "responsibleUpdate", width: '180px' },
        { text: "Preto Cronograma", value: "blackTimeline", width: '130px' },
        { text: "Projeção Preto / Inspeção", value: "blackProjectionInspection", width: '180px' },
        { text: "Pintura Cronograma", value: "paintingTimeline", width: '100px' },
        { text: "Projeção Pintura / Inspeção", value: "paintingProjectionInspection", width: '180px' },
        // { text: "Prazo do Pedido", value: "purchaseDeadline", width: '100px' },
        { text: "RID", value: "rid", width: '100px' },
        { text: "Inspetor", value: "inspector", width: '100px' },
        { text: "Status do Item", value: "itemStatus", width: '100px' },
        { text: "Pendências / Observações", value: "pendencyObservations", width: '100px' },
        { text: "Número da Nota Fiscal", value: "nf", width: '100px' },
        { text: "Data de Embarque", value: "shippingDate", width: '100px' },
      ],
      items: [],
      dateColumns: [
        "startManufacturing",
        "updateDate",
        "blackTimeline",
        "blackProjectionInspection",
        "paintingTimeline",
        "paintingProjectionInspection",
      ],
      customItemsPerPageOptions: [
      { title: '50', value: 50 },
      { title: '100', value: 100 },
      { title: '150', value: 150 },
      { title: '200', value: 200 }
    ], // Opções de limite
    };
  },
  computed: {
    themeClass() {
      return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
    },
  },
  methods: { 

    trackEdit(item) {
      this.editedItems.add(item);
      console.log(this.editedItems)
    },

    updateItemsPerPage(newLimit) {
      this.itemsPerPage = newLimit;
      // console.log("Novo limite de itens por página:", newLimit);
    },

    updatePage(newPage) {
      this.currentPage = newPage;
      // console.log("Nova página:", newPage);
    },
    
    // Abre o modal de filtros
    openFilterDialog() {
      this.filterDialog = true;
    },

    // Fecha o modal de filtros
    closeFilterDialog() {
      this.filterDialog = false;
    },

    // Limpa todos os filtros
    clearAllFilters() {
      this.filters = {
        osCodigo: "",
        jobCodigo: "",
        fornecedorNome: "",
        pedidoDeCompraCodigo: "",
        osItemStatus: "",
        osItemSequencia: "",
        osItemDescricao: "",
      };
    },

    async getTenanty(){
      const lc = window.localStorage.getItem("user-login");
      const user = JSON.parse(lc);
      this.userEmail = user[1];
    },

    async saveLines() {
      if (this.editedItems.size > 0) {
        const itemsParaAtualizar = Array.from(this.editedItems);

        console.log("Items para atualizar: ", itemsParaAtualizar);

        // Remove duplicados pelo trio osItemId, jobId, seq
        let seen = new Set();
        let payload = itemsParaAtualizar.map(item => {
          return {
            osItemId: item.osItemId,
            jobId: item.job,
            seq: Number(item.seq.split(".")[0]) ?? Number(item.seq),
          }
        }).filter(item => {
          let key = `${item.osItemId}_${item.jobId}_${item.seq}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });

       



        // let jobId = itemsParaAtualizar.map(item => item.job);
        // let seq = itemsParaAtualizar.map(item => item.seq);
        // console.log("OS Items: ", osItems);
        // console.log("Job ID: ", jobId);
        // console.log("Seq: ", seq);

        
        try {
          // console.log(this.items.find(line => line.osItemId === item.osItemId && line.seq.includes(".") && line.seq !== item.seq))
          // Cria um array de Promises
          const requests = itemsParaAtualizar.map(item => {
            
            const PutRequest = {
              "_id": item._id,
              "osItemId": item.osItemId,
              "osItemCodigo": item.osItemCodigo,
              "job": item.job,
              "jobCodigo": item.jobCodigo,
              "osCodigo": item.osCodigo,
              "supplier": item.fornecedorId,
              "destiny": item.destiny,
              "supplierName": item.fornecedorNome,
              "PC": item.pedidoDeCompraId,
              "pedidoDeCompraCodigo": item.pedidoDeCompraCodigo,
              "os": item.os,
              "seq": item.seq,
              "assemblyDrawing": item.assemblyDrawing || '',
              "drawingReview": item.drawingReview,
              "position": item.position,
              "manufacturingDrawing": item.manufacturingDrawing || '',
              "manufacturingReview": item.manufacturingReview,
              "qtd": item.qtd,
              "description": item.description || '',
              "totalWeight": item.totalWeight || 0,
              "rawMaterial": item.rawMaterial || 0,
              "preparationCutting": Number(item.preparationCutting),
              "boilermakingMachining": Number(item.boilermakingMachining),
              "finishingWelding": Number(item.finishingWelding),
              "painting": Number(item.painting),
              "inspectionTests": Number(item.inspectionTests),
              "shippingWeight": item.shippingWeight,
              "fullAdvance": item.fullAdvance,
              "osBalance": item.osBalance,
              "startManufacturing": item.startManufacturing,
              "updateDate": moment(new Date()).format('YYYY-MM-DD'),
              "responsibleUpdate": this.userEmail,
              "blackTimeline": item.blackTimeline,
              "blackProjectionInspection": item.blackProjectionInspection,
              "paintingTimeline": item.paintingTimeline,
              "paintingProjectionInspection": item.paintingProjectionInspection,
              "purchaseDeadline": item.purchaseDeadline,
              "rid": item.rid,
              "inspector": item.inspector,
              "itemStatus": item.itemStatus,
              "pendencyObservations": item.pendencyObservations,
              "nf": 0,
              "shippingDate": "",
              "createAt": item.createAt,
              "createBy": item.createBy,
              "updateAt": new Date().toISOString(),
              "updateBy": this.userEmail,
              "deleteAt": null,
              "deleteBy": null,
              "isDeleted": false
            };
            // console.log(PutRequest)

            // Retorna a Promise da requisição axios
            return axios.put(`${process.env.VUE_APP_API_PAV}/Api/PAV`, [PutRequest]);
            // return axios.put(`http://localhost:3001/Api/PAV`, [PutRequest]);
          });

          // Aguarda todas as requisições serem concluídas
          await Promise.all(requests);

          // Agora chama o this.getPGP() após todas as requisições concluírem


          // axios.put(`${process.env.VUE_APP_API_PAV}/Api/PAV`, );


           console.log("OS Items: ", payload);

          try {
            for (const item of payload) {
              const response = await axios.put(`${process.env.VUE_APP_API_PAV}/Api/PAVParent`, item);

              if (response.status === 200) {
                this.editedItems = new Set();
              }
            }
            Vue.prototype.$notify({
                title: "Planilha de avanço atualizada com sucesso!",
                closeOnClick: true,
                duration: 3000,
                positions: "right",
                type: "success",
              });
              
            await this.getPGP();
          } catch (error) {
            Vue.prototype.$notify({
              title: "Houve um erro ao atualizar a planilha de avanço.",
              closeOnClick: true,
              duration: 3000,
              positions: "right",
              type: "error",
            });
          }


          await this.getPGP();

          this.editedItems = new Set();

        } catch (error) {
          Vue.prototype.$notify({
            title: "Erro ao Editar!",
            closeOnClick: true,
            duration: 3000,
            positions: "right",
            type: "error",
          });
        }
      }
    },

    // Limpa todos os filtros
    clearFilter(key) {
      this.filters[key] = ""; 
      this.getPGP();  
    },

    // Aplica os filtros (exemplo: atualiza itens da tabela)
    applyFilters() {
      // console.log("Filtros aplicados:", this.filters);
      this.getPGP();
      this.closeFilterDialog();
    },
    // GET de Linhas da Tabela de PGP
    async getPGP() {
      const requestData = {
        params: [
          {
            name: "osCodigo",
            dataType: "String",
            value: this.filters.osCodigo
          },
          {
            name: "jobCodigo",
            dataType: "String",
            value: this.filters.jobCodigo
          },
          {
            name: "fornecedorNome",
            dataType: "String",
            value: this.filters.fornecedorNome
          },
          {
            name: "pedidoDeCompraCodigo",
            dataType: "String",
            value: this.filters.pedidoDeCompraCodigo
          },
          {
            name: "osItemStatus",
            dataType: "String",
            value: this.filters.osItemStatus
          },
          {
            name: "osItemSequencia",
            dataType: "String",
            value: this.filters.osItemSequencia
          },
          {
            name: "osItemDescricao",
            dataType: "String",
            value: this.filters.osItemDescricao
          },
        ],
        viewName: "get-pgp",
        page: 1,
        limit: 99999999
      };

      try {
        const response = await Vue.prototype.$http.post('/View/run', requestData);

        if (response && response.data) {
          // Adiciona a propriedade 'editable: true' aos itens com '.' no seq
          // console.log('reponsedataata::',response.data.data.data)
          this.items = response.data.data.data.flatMap(item =>
            item.pav.map(pavItem => pavItem)
          );

          this.filterJob = [...new Set(response.data.data.data.map(item => item.jobCodigo))];
          this.filterOs = [...new Set(response.data.data.data.map(item => item.osCodigo))];
          this.filterSupplier = [...new Set(response.data.data.data.map(item => item.fornecedorNome))];
          this.filterPedidoDeCompra = [...new Set(response.data.data.data.map(item => item.pedidoDeCompraCodigo))];
          console.log('FILTERJOB',this.filterJob)

          // console.log(this.items); // Verifica se os dados foram modificados corretamente
        } else {
          console.warn("A resposta da API não contém dados esperados:", response);
        }

        console.log("Itens carregados:", this.items);
      } catch (error) {
        console.error("Erro ao carregar os dados do PGP:", error);
      }
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.getPGP();
      }
    },
  },
  created() {
    this.getTenanty();
    this.getPGP();
  }
};
</script>
<style scoped>

  .v-data-table thead th,
  .v-data-table tbody td {
    text-overflow: ellipsis; /* Trunca textos longos */
    white-space: pre-wrap;
  }

  ::-webkit-scrollbar {
    height: 5px !important;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #230BC1 !important;
  }

  .v-data-table--dense > .v-data-table__wrapper > table > thead > tr > th {
    height: 48px;
    border-bottom: 0;
  }

  .v-application--is-ltr .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    text-align: center !important;
    border-bottom: 0 !important;
  }

  .statusTd {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 53px !important;
  }

  .activeCircle {
    border: 1px solid rgb(197, 167, 34);
    border-radius: 100%; 
    height: 0.5rem; 
    width: 0.5rem; 
    opacity: 80%; 
    background-color: rgb(34 197 94);
  }

  .inactiveCircle {
    border: 1px solid rgb(197, 167, 34);
    border-radius: 100%; 
    height: 0.5rem; 
    width: 0.5rem; 
    opacity: 80%; 
    background-color: #F00;
  }

  .v-application .elevation-1 {
    box-shadow: none !important;
  }

  .mdi-arrow-up::before {
    font-size: 15px !important;
  }

  .mdi-arrow-up::after {
    font-size: 15px !important;
  }

  .actionIcon {
    font-size: 18px !important;
  }

  .v-text-field--outlined fieldset {
    border: 0;
    border-bottom: 1px solid black;
    border-radius: 0;;
  }

  .v-text-field--outlined .v-text-field__slot {
    align-items: end !important;
  }

  .v-text-field .v-input__slot {
    padding: 0 !important;
  }

  .filterInput {
    outline: none;
    border: 1px solid #e1e1e1;
    color: #000;
    border-radius: 4px;
    margin-right: 18px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  .theme--dark > .filterInput {
    outline: none;
    border: 1px solid #e1e1e1;
    color: #FFF !important;
    border-radius: 4px;
    margin-right: 18px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  .filterInputDate {
    outline: none;
    border: 1px solid #666;
    border-radius: 4px;
    margin-right: 18px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    cursor: pointer;
    border-radius: 4px;
    margin-right: 2px;
    opacity: 0.6;
    filter: invert(0.8);
  }

  .container {
    margin-right: 0;
    margin-left: 0;
    max-width: 100%;
  }

  .filterDialog {
    margin-top: 280px !important;
  }

  .filterSelect {
    border: 1px solid #e1e1e1;
    width: 270px;
    border-radius: 5px;
    height: 40px;
    padding-left: 10px;
    outline: 0;
  }

  .dialogTitle {
    color: #FFF;
    /* background-color: #230BC1; */
    padding: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  } 
  
  .theme--dark > .dialogTitle {
    color: #000;
  }

  .filterButton {
    color: #230BC1 !important;
    background-color: #FFF !important;
  }

  #deleteModal {
    align-items: center !important;
    justify-content: center !important;
  }

   .dark-theme {
    background-color: #1E1E1E;
  }

  .v-slide-group__prev, .v-slide-group__prev--disabled {
    display: none !important;
  }

  .v-slide-group__next--disabled, .v-slide-group__prev--disabled {
    display: none !important;
  }

  .dark-theme {
    color: white;
  }

  .light-theme {
    color: #666;
  }

  .custom-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* Fundo escuro com opacidade reduzida */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  /* Estilos para o modal */
  .custom-modal {
    border-radius: 8px;
    width: 500px; /* Largura fixa */
    max-width: 90%; /* Responsividade: ajusta para telas menores */
    padding: 16px;
    z-index: 10000; /* Certifica que o modal está acima do overlay */
  }

  .theme--dark.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th {
    background-color: #1F1F1F;
  }

  ::v-deep(.v-data-table-header) {
    position: relative;
    z-index: 5 !important;
  }
</style>